"use client";

import dynamic from "next/dynamic";

// Dependency-free fallback so error UI is never blank if the DDS chunk fails
// to load (network/CDN issue) or hasn't downloaded yet on the very render
// that follows a server error. Text intentionally matches DDS ErrorDisplay's
// own copy to avoid a layout shift when the real component swaps in.
const InlineErrorFallback = () => (
  <p
    role="alert"
    style={{
      margin: "24px",
      fontSize: "16px"
    }}
  >
    Page error. Some content may not be available. Refresh the page or try again later.
  </p>
);

// Shared by every app/v2/*/error.tsx and app/error.tsx boundary — avoids
// redefining the same dynamic-import wrapper and fallback in each file.
export const ErrorDisplay = dynamic(
  () => import("@directv-digital/dds.ui.error-display"),
  {
    ssr: false,
    loading: InlineErrorFallback
  }
);
